export const PAGE_CONTENT_MAX_WIDTH = "75rem"

export const HEADER_NAVBAR_HEIGHT = "3rem"
export const HEADER_ANNOUNCEMENT_BANNER_HEIGHT = "4rem"
export const HEADER_TITLE_AND_BREADCRUMB_HEIGHT = "3rem"
export const STUDY_STEPPER_HEIGHT = "3rem"
